import { bool, number } from "prop-types";
import { markerTypes } from "./annotationCommonPropTypes.js";
import { AnnotationContextProvider } from "./AnnotationContext.jsx";
import AnnotationMarker from "./AnnotationMarker.jsx";
import AnnotationModal from "./AnnotationModal.jsx";

const propTypes = {
  markerType: markerTypes, // see ./annotationCommonPropTypes.js
  markerPositionTop: number,
  markerPositionRight: number,
  markerNoColor: bool,
};

const Annotation = (props) => {
  const {
    markerType,
    markerPositionTop,
    markerPositionRight,
    markerNoColor,
    ...data
  } = props;

  const isAnnotated = data.annotations.length > 0;

  let highlightType = null;

  switch (markerType) {
    case "plainFlagWithSelection":
    case "squareFlagWithSelection":
      highlightType = "selection";
      break;
    default:
      highlightType = "overlay";
  }

  // Pass the context info down through the provider
  return (
    <AnnotationContextProvider
      markerType={markerType}
      markerPositionTop={markerPositionTop}
      markerPositionRight={markerPositionRight}
      markerNoColor={markerNoColor}
      data={data}
    >
      <AnnotationMarker
        highlightType={highlightType}
        isAnnotated={isAnnotated}
      />
      <AnnotationModal
        highlightType={highlightType}
        isAnnotated={isAnnotated}
      />
    </AnnotationContextProvider>
  );
};

Annotation.propTypes = propTypes;
export default Annotation;
